<template>
  <section>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <h5 class="mr-sm-2 ">
              <b>Passkeys Authentication</b><br/>
            </h5>
            <hr>
            <div v-if="!allPasskeys.length" style="display: flex; justify-content: space-between; align-items: baseline">
              <div style="font-size: 16px">Add your passkey for one click Authentication</div>
              <button type="submit" class="btn btn-warning" @click.prevent="addPasskey()">Add Passkey</button>
            </div>
            <div v-else>
<!--              <div style="font-size: 16px"><b>Passkeys</b></div>-->
<!--              <p style="font-size: 16px">Your passkeys allow you to sign in to this account.</p>-->
              <div v-for="(passkey, index) of allPasskeys" :key="index" style="display: flex; justify-content: space-between; align-items: baseline">
                <div style="font-size: 16px">
                  <p style="font-size: 16px">Your passkeys allow you to sign in to this account.</p>
                </div>
                <button type="submit" class="btn btn-danger" @click.prevent="removePasskey(passkey)">
                  <span v-if="loading === passkey.credential.id">
                    <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                  </span>
                  <span v-else>
                    Remove this Passkey
                  </span>
                </button>
              </div>
<!--              <button class="btn btn-warning btn-round" @click.prevent="addPasskey()">-->
<!--                <i class="fa fa-plus"></i>-->
<!--                Add Another Passkey-->
<!--              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stepModal position-relative">
      <div class="modal fade" id="passkey" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="twoFAStepModal">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="twoFAStepModalHeader">Add Passkeys</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <section>
                <div>
                  <label><b>Add your passkey</b></label>
                </div>
                <div>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model.trim="passkey">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button :disabled="loading" class="btn btn-primary btn-sm pull-right" @click="processPasskey()">
                      <span v-if="loading">
                        <div class="loader" style="width: 15px;height: 15px; margin: 0.2rem 0 !important;"></div>
                      </span>
                      <span v-else>
                        Next
                      </span>
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {create} from "@github/webauthn-json";
import axios from 'axios';
import {config} from "@/config";
import { db } from "@/firebase/init";

const tenantId = config.PASSKEY_TENANT_ID;

const apiKey = config.PASSKEY_SECRET_SECRET_KEY;

const baseUrl = `https://passkeys.hanko.io/${tenantId}`;

const headers = { apiKey, 'Content-Type': 'application/json' };
export default {
  name: "Passkeys",
  data () {
    return {
      passkey: '',
      loading: false,
      allPasskeys: []
    }
  },
  computed:{
    user() {
      return this.$store.getters.user;
    },
  },
  mounted() {
    this.getPasskeys()
  },
  methods: {
    async getPasskeys () {
      try {
        const ref = await db.collection('passkeys').doc(this.user.uid).get();
        if (ref.data()) {
          this.allPasskeys = ref.data().passkeys
        }
      } catch (e) {
        console.log(e.toString())
      }
    },
    addPasskey () {
      $('#passkey').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async removePasskey (passkey) {
      const credential_id = passkey.credential.id
      this.loading = credential_id
      try {
        await axios.delete(`${baseUrl}/credentials/${credential_id}`, {
          headers,
        });
        this.allPasskeys = this.allPasskeys.filter(el => el.credential.id !== credential_id)
        await db.collection('passkeys').doc(this.user.uid).update({
          passkeys: this.allPasskeys
        });
        this.showToast({ message: 'Successfully Removed the Passkeys.', duration: 5000 }, true, 'success')
      } catch (e) {
        console.log(e.toString())
      }
      this.loading = false
    },
    async processPasskey () {
      if (!this.passkey) {
        return
      }
      this.loading = true
      try {
        const data = {
          user_id: this.user.uid,
          username: this.passkey,
        };
        const resp = await axios.post(`${baseUrl}/registration/initialize`, data, {
          headers,
        });
        const creationOptions = resp.data;
        resp.data.publicKey.authenticatorSelection.userVerification = 'discouraged'
        resp.data.publicKey.authenticatorSelection.requireResidentKey = false
        console.log('resp.data', resp.data)
        const credential = await create(creationOptions)
        const resp1 = await axios.post(`${baseUrl}/registration/finalize`, credential, {
          headers,
        });
        if (this.allPasskeys.length) {
          this.allPasskeys.push({...data, credential})
          await db.collection('passkeys').doc(this.user.uid).update({
            passkeys: this.allPasskeys
          });
        } else {
          this.allPasskeys.push({...data, credential})
          await db.collection('passkeys').doc(this.user.uid).set({
            passkeys: this.allPasskeys
          });
        }
        // const resp = await this.$reportService.post('/passkey/start-registration', {
        //   grant_type: 'token',
        //   username: this.passkey,
        //   id: this.user.uid,
        // })
        // const credential = await create(resp.data.creationOptions)
        // const resp1 = await this.$reportService.post('/passkey/finalize-registration', credential)
        console.log(resp1)
        this.showToast({message: 'Success!', duration: 5000}, true, 'success')
        $('#passkey').modal('hide');
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
